import React, { useState } from "react";
import { createWorkOrderTemplate, updateWorkOrderTemplate } from "../api/WorkOrderTemplate";

function WorkOrderTemplateModal({ template = {}, onClose, onSave }) {
  const [name, setName] = useState(template.name || "");
  const [description, setDescription] = useState(template.description || "");
  const [priority, setPriority] = useState(template.priority || "Medium");
  const [dueDate, setDueDate] = useState(template.dueDate || "");
  const [status, setStatus] = useState(template.status || "Open");
  const [customer, setCustomer] = useState(template.customer || "");
  const [contact, setContact] = useState(template.contact || "");
  const [notes, setNotes] = useState(template.notes || "");
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (isSubmitting) return; // Prevent duplicate submissions
    setIsSubmitting(true);
  
    console.log("Submitting form...");
  
    if (!name.trim()) {
      alert("Template name is required");
      setIsSubmitting(false);
      return;
    }
  
    const newTemplate = {
      name,
      description,
      priority,
      dueDate: dueDate || null,
      status,
      customer,
      contact,
      notes,
    };
  
    try {
      setLoading(true);
  
      if (template.workOrderTemplateID) {
        const updatedTemplate = await updateWorkOrderTemplate(template.workOrderTemplateID, newTemplate);
        console.log("Updated template:", updatedTemplate);
        onSave(updatedTemplate);
      } else {
        const createdTemplate = await createWorkOrderTemplate(newTemplate);
        console.log("Created template:", createdTemplate);
        onSave(createdTemplate);
  
        // Reset form state for new templates
        setName("");
        setDescription("");
        setPriority("Medium");
        setDueDate("");
        setStatus("Open");
        setCustomer("");
        setContact("");
        setNotes("");
      }
  
      onClose();
    } catch (error) {
      console.error("Error saving work order template:", error);
      alert("Failed to save template. Please try again.");
    } finally {
      setLoading(false);
      setIsSubmitting(false); // Reset flag
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg">
        {/* Header */}
        <div className="p-4 border-b bg-gray-100">
          <h2 className="text-lg font-bold">
            {template.workOrderTemplateID ? "Edit Work Order Template" : "Add Work Order Template"}
          </h2>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium">Template Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter template name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter template description"
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium">Priority</label>
              <select
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                className="w-full p-2 border rounded"
              >
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Due Date</label>
              <input
                type="date"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
                className="w-full p-2 border rounded"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium">Status</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="w-full p-2 border rounded"
              >
                <option value="Open">Open</option>
                <option value="In Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Customer</label>
              <input
                type="text"
                value={customer}
                onChange={(e) => setCustomer(e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Enter customer name"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium">Contact</label>
            <input
              type="text"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter contact details"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Notes</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Add any additional notes"
            ></textarea>
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t bg-gray-100 flex justify-end space-x-4">
          <button onClick={onClose} className="px-4 py-2 bg-gray-500 text-white rounded-md">
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded-md"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WorkOrderTemplateModal;